import { render, staticRenderFns } from "./OurEmperor.vue?vue&type=template&id=8e3b32f0&scoped=true"
import script from "./OurEmperor.vue?vue&type=script&lang=js"
export * from "./OurEmperor.vue?vue&type=script&lang=js"
import style0 from "./OurEmperor.vue?vue&type=style&index=0&id=8e3b32f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3b32f0",
  null
  
)

export default component.exports